import { MaterialIcon } from "@website/icons/material";
import { useTextField } from "@website/ui-old/text-field/text-field.hook";
import styles from "@website/ui-old/text-field/text-field.module.scss";
import { TextFieldPropertiesType } from "@website/ui-old/text-field/text-field.types";
import { FC, memo } from "react";

const TextField: FC<TextFieldPropertiesType> = (properties) => {
  const {
    className,
    disabled,
    error,
    EndIcon,
    fullWidth,
    helperText,
    label,
    prefix,
    size = "default",
    StartIcon,
    suffix,
    inputMode = "text",
    noBorder,
    staticDirection,
    id,
    textCenter,
    hideBorders,
    hasTitleLabel,
    helperTextClass
  } = properties;
  const {
    rootProperties,
    inputProperties,
    startIconProperties,
    endIconProperties
  } = useTextField(properties);

  return (
    <div
      className={`${styles["container"]} ${error ? styles["error"] : ""} ${
        disabled ? styles["disabled"] : ""
      } ${styles[size]} ${fullWidth ? styles["fullWidth"] : ""} ${noBorder
        ?.map((item) => `${styles[`no-border-${item}`]}`)
        .join(" ")} ${className ?? ""}`}
      {...rootProperties}
      id={id}
    >
      {hasTitleLabel && (
        <div className="text-body-2 text-on-surface-medium-emphasis flex gap-1 px-4">
          {inputProperties?.value ? (
            <div className="h-[20px]" />
          ) : (
            <>
              <div>{properties?.placeholder}</div>
              <div>
                <MaterialIcon className="text-[16px]" name="arrow_drop_down" />
              </div>
            </>
          )}
        </div>
      )}
      <div
        className={`${styles["box"]} ${hideBorders ? "!border-0" : ""} ${
          hasTitleLabel ? "!h-[28px]" : ""
        }`}
      >
        {StartIcon ? (
          <div {...startIconProperties} className={styles["start-icon"]}>
            {StartIcon}
          </div>
        ) : null}
        {prefix ? <div className={styles["prefix"]}>{prefix}</div> : null}
        <input
          {...inputProperties}
          className={`${styles["input"]} ${label ? styles["has-label"] : ""} ${
            staticDirection ? styles[staticDirection] : ""
          } ${textCenter && "text-center"}`}
          inputMode={inputMode}
        />
        {suffix ? <div className={styles["suffix"]}>{suffix}</div> : null}
        {EndIcon ? (
          <div {...endIconProperties} className={styles["end-icon"]}>
            {EndIcon}
          </div>
        ) : null}
        {label ? (
          <label
            className={`${styles["label"]} ${
              prefix || StartIcon ? styles["active"] : ""
            }`}
          >
            {label}
          </label>
        ) : null}
      </div>
      {helperText ? (
        <div className={`${styles["helper-text"]} ${helperTextClass}`}>
          {helperText}
        </div>
      ) : null}
    </div>
  );
};

const TextFieldMemoized = memo(TextField);
/**
 * @deprecated please use @website/ui instead
 */
export { TextFieldMemoized /**
 * @deprecated please use @website/ui instead
 */ as TextField };
